import React from "react";
import { Button } from "@mui/material";

function SquareButton(props) {
  return <Button {...props} sx={{ minWidth: 40, minHeight: 40, padding: 0 }} />;
}

export default SquareButton;
